module.exports = __webpack_public_path__ + "img/check-white.2f9e999d.svg";